module.exports = __webpack_public_path__ + "media/images/___novum-logo-animated-short-c1b21b748fb01c60b5ee5d3c946d554a.svg";